import { Appointment, DisplayExport, proposeWorkItemCancel, proposeWorkItemContinueForm, proposeWorkItemJoinVideo, proposeWorkItemSendReminder, proposeWorkItemStartEncounter, proposeWorkItemViewForm, WorkItemAction } from "@fusion-advantage/formlib"
import { useAppSelector } from "../../../redux/hooks"
import { V2L3ApptReadyDetail, ReminderState } from "@fusion-advantage/formrender"
import { selectDashboardDisplayIdentity } from "../../../redux/dashboardDataSlice"

interface LxApptReadyDetailProps {
	appt: Appointment
	displayExp: DisplayExport
	pendingSync: boolean
	onActionClick: (action: WorkItemAction) => void
}

export const LxApptReadyDetail = ({appt, displayExp, pendingSync, onActionClick}: LxApptReadyDetailProps) => {
	const filterByDate = useAppSelector(state => state.dashboardData.filterByDate)
	const user = useAppSelector(selectDashboardDisplayIdentity)
	const isJoiningVideo = useAppSelector(state => Boolean(state.app.ldng.apiDashboardGenerateUrls))
	const clinicianHasJoined = useAppSelector(state => Boolean(state.dashboardControl.joinedVideoEncounters[displayExp.encounterGuid]))
	const qtySentReminders = useAppSelector(state => state.dashboardControl.sentReminders[displayExp.encounterGuid] ?? 0)
	const videoBobJobberOpen = useAppSelector(state => state.dashboardControl.videoBobJobberOpen)
	const reminderLoading = useAppSelector(state => Boolean(state.app.ldng.apiDashboardApptSendReminder))
	let reminderState = ReminderState.Ready
	if(reminderLoading) {
		reminderState = ReminderState.Loading
	} else if(qtySentReminders >= 1) {
		reminderState = ReminderState.Sent
	}
	return (
		<V2L3ApptReadyDetail
			appt={appt}
			dexp={displayExp}
			pendingSync={pendingSync}
			canViewForm={proposeWorkItemViewForm(appt, filterByDate).isOk()}
			canStartEncounter={proposeWorkItemStartEncounter(appt, displayExp, filterByDate).isOk()}
			canContinueForm={proposeWorkItemContinueForm(appt, displayExp, filterByDate, user).isOk()}
			canJoinVideo={proposeWorkItemJoinVideo(appt, displayExp, filterByDate).isOk()}
			isJoiningVideo={isJoiningVideo}
			canSendReminder={proposeWorkItemSendReminder(appt, displayExp, filterByDate, clinicianHasJoined, qtySentReminders).isOk()}
			videoBobJobberOpen={videoBobJobberOpen}
			reminderState={reminderState}
			canCancel={proposeWorkItemCancel(appt, displayExp, filterByDate).isOk()}
			onActionClick={onActionClick}
		/>
	)
}
